import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    marginTop: theme.spacing(0.5)
  },
  labelText: {
    alignSelf: 'center',
  },
  asterisk: {
    marginLeft: theme.spacing(1),
    alignSelf: 'center',
    color: '#E50046',
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 600
  }
}));

const RequiredFieldsFormLabel = React.forwardRef(
  function ({ className }, ref) {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
      <label ref={ref} className={clsx(classes.root, className)}>
        <Typography className={classes.labelText} variant="body2" color="textPrimary">
          {t('requiredFieldsFormLabel.description')}
        </Typography>
        <span className={classes.asterisk}>*</span>
      </label>
    );
  }
);

RequiredFieldsFormLabel.propTypes = {
  className: PropTypes.string
};

RequiredFieldsFormLabel.displayName = 'RequiredFieldsFormLabel';
export default RequiredFieldsFormLabel;
